/**
 * No need to get this content from JSON as its mostly gonna remain unchanged
 */
import React, { Component } from 'react';
import './Footer.css';
import Button from '@material-ui/core/Button';
import {
  FaTwitter,
  FaGithub,
  FaMedium,
  FaStackOverflow,
  FaDev
} from 'react-icons/fa';

class Footer extends Component {
  render() {
    const heart = '\u2665'; // ascii
    return (
      <div className='screen footer'>
        <div className='quick-links'>
          <Button className='footer-links'>
            <FaTwitter className='fa-icon' />
          </Button>
          <Button className='footer-links'>
            <FaGithub className='fa-icon' />
          </Button>
          <Button className='footer-links'>
            <FaMedium className='fa-icon' />
          </Button>
          <Button className='footer-links'>
            <FaStackOverflow className='fa-icon' />
          </Button>
          <Button className='footer-links'>
            <FaDev className='fa-icon' />
          </Button>
        </div>
        <div className='react-credit'>
          <p>
            Made in React{' '}
            <span
              className='red'
              dangerouslySetInnerHTML={{ __html: heart }}
            ></span>{' '}
            Last Updated Apr 2020
          </p>
        </div>
      </div>
    );
  }
}

export default Footer;
